import React from "react";


interface ModalContextProps {
    modal: JSX.Element | null;
    setModal: React.Dispatch<React.SetStateAction<JSX.Element| null>>;
}

export const ModalContext = React.createContext<ModalContextProps>({} as ModalContextProps);


const ModalContextProvider = ({children}: any) => {
    const [modal, setModal] = React.useState<JSX.Element | null>(null)
    const providerInterface = React.useMemo(() => ({
        modal, setModal
    }), [modal])
  return (
    <ModalContext.Provider value={providerInterface}>
        {children}
    </ModalContext.Provider>
  )
}

export default ModalContextProvider;
